(function () {
  const initAhmNavigation = () => {
    const siteHeader = document.querySelector(".ahm-site-header");
    const menuToggle = document.querySelector("[data-ahm-menu-toggle]");
    const menuClose = document.querySelector("[data-ahm-menu-close]");
    const mainNav = document.querySelector("[data-ahm-main-nav]");
    const navItems = document.querySelectorAll(".ahm-nav-item");

    const updateMegaMenuTop = () => {
      if (!siteHeader) return;
      const offset = siteHeader.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty("--ahm-mega-menu-top", `${offset}px`);
    };

    const closeNav = () => {
      if (!mainNav || !menuToggle) return;
      mainNav.classList.remove("is-open");
      menuToggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("ahm-menu-open");
    };

    updateMegaMenuTop();
    window.addEventListener("resize", updateMegaMenuTop);
    window.addEventListener("scroll", updateMegaMenuTop, { passive: true });

    let megaCloseTimer = null;

    const openMega = (item) => {
      clearTimeout(megaCloseTimer);
      navItems.forEach((el) => el.classList.remove("mega-hover"));
      item.classList.add("mega-hover");
    };

    const scheduleCloseMega = () => {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(() => {
        navItems.forEach((el) => el.classList.remove("mega-hover"));
      }, 180);
    };

    navItems.forEach((item) => {
      const mega = item.querySelector(".ahm-mega-menu--products");
      if (!mega) return;

      item.addEventListener("mouseenter", () => openMega(item));
      item.addEventListener("mouseleave", scheduleCloseMega);
      mega.addEventListener("mouseenter", () => openMega(item));
      mega.addEventListener("mouseleave", scheduleCloseMega);
    });

    if (menuToggle && mainNav) {
      menuToggle.addEventListener("click", () => {
        const isOpen = mainNav.classList.toggle("is-open");
        menuToggle.setAttribute("aria-expanded", String(isOpen));
        document.body.classList.toggle("ahm-menu-open", isOpen);
        if (isOpen) updateMegaMenuTop();
      });
    }

    if (menuClose) {
      menuClose.addEventListener("click", closeNav);
    }

    document
      .querySelectorAll(".ahm-main-nav .ahm-nav-link, .ahm-mobile-shop-cta")
      .forEach((link) => {
        link.addEventListener("click", closeNav);
      });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      closeNav();
      navItems.forEach((item) => item.classList.remove("mega-hover"));
      document.querySelectorAll(".ahm-header-search__details[open]").forEach((details) => {
        details.open = false;
      });
    });

    document.querySelectorAll(".ahm-header-search__details").forEach((details) => {
      details.addEventListener("toggle", () => {
        if (!details.open) return;
        const input = details.querySelector(".ahm-header-search__input");
        window.requestAnimationFrame(() => input?.focus());
      });
    });

    document.addEventListener("click", (event) => {
      if (event.target.closest(".ahm-predictive-search__link, .ahm-predictive-search__view-all")) {
        return;
      }

      document.querySelectorAll(".ahm-header-search__details[open]").forEach((details) => {
        if (!details.contains(event.target)) {
          details.open = false;
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAhmNavigation);
  } else {
    initAhmNavigation();
  }
})();
